import { useCallback, useState } from 'react';
import { useFocusEffect } from '@betty/navigation';
import { logError } from '@betty/toolkit/logging';
import {
  TransactionStatus,
  TransactionStatusParams,
} from '../state/payment/payment.types';
import PaymentService from '../services/PaymentService/PaymentService';

const usePaymentStatus = ({
  transactionId,
  externalTransactionId,
}: TransactionStatusParams) => {
  const [data, setData] = useState<TransactionStatus>();

  const fetch = useCallback(async () => {
    try {
      setData(undefined);

      const data = await PaymentService.getTransactionStatus({
        params: { transactionId, externalTransactionId },
      });

      setData(data);
    } catch (error) {
      logError('Transaction status request failure.', error);
    }
  }, [transactionId, externalTransactionId]);

  useFocusEffect(
    useCallback(() => {
      fetch();
    }, [fetch]),
  );

  return { data, fetch };
};

export default usePaymentStatus;
